// ===== Mueblika · Página legal =====
// Resalta en el índice el apartado que se está leyendo, mientras
// haces scroll por el documento (usa IntersectionObserver).

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-mbk-legal-section]');
    var tocLinks = document.querySelectorAll('[data-mbk-toc-link]');
    if (!sections.length || !tocLinks.length) return;

    function setActive(id) {
      tocLinks.forEach(function (link) {
        link.classList.toggle('is-active', link.dataset.target === id);
      });
    }

    if (!('IntersectionObserver' in window)) {
      // Navegador muy antiguo: sin resaltado dinámico, pero los
      // enlaces del índice siguen funcionando igualmente
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  });
})();